const defaultAccordionItem = $('body').hasClass('template-index') ? 2 : 3;
$('.accordion__container .accordion__item:nth-child(' + defaultAccordionItem + ') .accordion__button').addClass('active');
$('.accordion__container .accordion__item:nth-child(' + defaultAccordionItem + ') .accordion__content-text').slideDown();
$('.accordion__button').on('click', function() {
    if($(this).hasClass('active')) {
    $(this).siblings('.accordion__content-text').slideUp();
    $(this).removeClass('active');
    }
    else {
    $('.accordion__content-text').slideUp();
    $('.accordion__button').removeClass('active');
    $(this).siblings('.accordion__content-text').slideToggle();
    $(this).toggleClass('active');
    }
}); 